import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { withStyles, WithStyles, Box } from '@material-ui/core';
import IconsButton from '../../../shared/Buttons/IconsButton';
import { connect } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Delete from '../Delete/Delete.container';
import { showToast } from '../../../../redux/actions/toasts';

const styles = {
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '20px',
  },
};

interface RoleData {
  id: string;
  name: string;
  userCount: number;
  isSystemRole: boolean;
}

interface RolesActionButtonsProps
  extends WithStyles<typeof styles>,
    RouteComponentProps {
  data: RoleData;
  showToast: any;
}

class RolesActionButtons extends Component<RolesActionButtonsProps> {
  state = {
    deleteOpen: false,
  };
  handleOpen = () => {
    if ((this.props.data.userCount || 0) === 0) {
      this.setState((prevState) => ({
        ...prevState,
        deleteOpen: true,
      }));
    } else {
      this.props.showToast('Please remove all the users to delete this role.');
    }
  };

  handleClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      deleteOpen: false,
    }));
  };

  render() {
    const { classes, data, history } = this.props;

    const handleEditClick = () => {
      history.push(`/editRole/${data.id}`);
    };

    const handleViewClick = () => {
      history.push(`/viewRole/${data.id}`);
    };

    return (
      <Box className={classes.buttonsContainer}>
        <Delete
          handleClose={this.handleClose}
          open={this.state.deleteOpen}
          roleName={data.name}
          roleId={data.id}
        />
        <IconsButton
          icon={VisibilityIcon}
          handleClick={handleViewClick}
          tooltip="View role"
        />
        <IconsButton
          icon={EditIcon}
          handleClick={handleEditClick}
          disabled={data?.isSystemRole}
          tooltip="Edit role"
          disabledTooltip="This is a system default role so it can't be edited."
        />
        <IconsButton
          icon={DeleteIcon}
          handleClick={this.handleOpen}
          disabled={data?.isSystemRole}
          tooltip="Delete role"
          disabledTooltip="This is a system default role so it can't be deleted."
        />
      </Box>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  showToast: (message) => dispatch(showToast({ message })),
});
export default withRouter(
  connect(
    null,
    mapDispatchToProps,
  )(withStyles(styles, { withTheme: true })(RolesActionButtons)),
);
